import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const TASK_HEADER_SCHEMA = Object.freeze({
  ACCOUNT_ID: '',
  VERSION: '',
});
export const RECORD = generateSchema(TASK_HEADER_SCHEMA);
export const KEYS: any = generateKeys(TASK_HEADER_SCHEMA);

export class TaskHeader extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get accountId(): string {
    return this.get(KEYS.ACCOUNT_ID);
  }

  get version(): string {
    return this.get(KEYS.VERSION);
  }
}
